import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {getLastLevelFields} from '../../Common/actions/Screen';
import {selectScrollField, saveData} from '../actions/Screen';
import {texts, getLocalizedText, categoryDesc} from '../../../../constants/TextConst';
import Search from '../../../../components/Common/Search';
import PackagesMenu from './PackagesMenu';
import List from '../../../../components/Common/List';
import {CollapsibleField} from '../../../../components/Common/Collapsible';
import {PackageCategoryField, PackageField} from './PackageField';
import {Text, Flex, Button} from '@priority-software/priority-style-react';

@observer
export default class Packages extends Component<any, any> {
    constructor(props) {
        super(props);

        this.selectSearchOption = this.selectSearchOption.bind(this);
        this.renderItem = this.renderItem.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    selectSearchOption(field) {
        selectScrollField(field);
    }

    handleCancel() {
        const {closePanel} = this.props;
        closePanel();
    }

    handleSave() {
        const {closePanel, screensStore, hidePanel} = this.props;
        hidePanel();
        saveData(screensStore, closePanel);
    }

    renderSearch() {
        const {screen} = this.props;

        return (
            <Search
                options={getLastLevelFields(screen)}
                placeholder={
                    getLocalizedText(texts.search) +
                    ' ' +
                    (screen.entityName ? screen.entityName : '')
                }
                onOptionSelect={this.selectSearchOption}
            />
        );
    }

    renderItem({item}) {
        return (
            <CollapsibleField
                field={item}
                renderParent={PackageCategoryField}
                renderChild={PackageField}
            />
        );
    }

    renderList() {
        const {screen} = this.props;
        return (
            <div className="list long">
                <div className="line" />
                <List
                    data={screen.collection.fields}
                    keyExtractor={field => field.name}
                    renderItem={this.renderItem}
                />
                {this.renderPackagesMenu()}
            </div>
        );
    }

    renderPackagesMenu() {
        const {selectedScreen} = this.props.screensStore;
        return <PackagesMenu designScreen={selectedScreen} />;
    }

    renderPackagesInfo() {
        const {screens} = this.props;
        const desc =
            screens && screens.P.sysCurrLang
                ? categoryDesc.info.descEnglish
                : categoryDesc.info.descHebrew;

        return (
            <div className="packages-info">
                <Text skin="paragraph-2" textColor="primary-700" tag="p">
                    {desc}
                </Text>
            </div>
        );
    }

    render() {
        const {selectedScreen} = this.props.screensStore;
        const {selected} = selectedScreen;
        return (
            <div
                className={`packages-container ${
                    selected && selected.collection.hasExpendedTab && 'packages-selected'
                }`}
            >
                <div className={`screen`}>
                    <div className="content-wrapper">
                        <div className="content">
                            {this.renderSearch()}
                            {this.renderList()}
                        </div>
                    </div>
                    <Flex componentClasses="panel-bottom">
                        <Button
                            skin="text"
                            width="regularFixed"
                            size="large"
                            onClick={this.handleCancel}
                        >
                            {getLocalizedText(texts.cancel)}
                        </Button>
                        <Button
                            skin="primary"
                            width="regularFixed"
                            size="large"
                            onClick={this.handleSave}
                        >
                            {getLocalizedText(texts.save)}
                        </Button>
                    </Flex>
                </div>
                {this.renderPackagesInfo()}
            </div>
        );
    }
}
